export const convertTime = (min, sec) => {
  return (`${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`);
};